import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './styles/settings.css';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";

// Themes
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '@styles/theme'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
